import { render, staticRenderFns } from "./user_button.vue?vue&type=template&id=557f972e&scoped=true&"
import script from "./user_button.vue?vue&type=script&lang=js&"
export * from "./user_button.vue?vue&type=script&lang=js&"
import style0 from "./user_button.vue?vue&type=style&index=0&id=557f972e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f972e",
  null
  
)

export default component.exports